module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABsAAAAYCAYAAAALQIb7AAABOUlEQVRIib2Wu0oDQRRAT0IMIalsBAstxDqVSa2ifkR+QOMf5EuEfEGwsrQLKVJYWKVJoSAqCOKjUsTmhpFZuKyb3Z2bbA4MzDKPMzN3dmZKIgLQAM6ANlBiubwAF8DUyWrAyIuK4gs4QkTOZTWMK0BLzeYRuF7i7HaBQ5/fc7KqKpwApxkdbPo45KGjZNWyYbQ3wI6hHRbZFjC0CC0yx7ZFaJWZhIvItHBjFTJCTpxFZU/AAfBatOzZi+7zNrDKnGg/RGSVBc8oomKQtQOOq1TZGrCe0eYnR52IRlz2pr5PgI/cQw3j3cXsEpCCBJqBuzxd6orId4FX6JWI1KM3CD4OTR+3JHrqbopznDKjB+CO2Ab59G8Rjd4IabG8VXn33vhNrOWXcV6y0JnXX9Z/1s8oT+Jvyf4BzAANXmOmyXMocAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/baiicon/icon_sp.png
// module id = CiB6
// module chunks = 10